import { render, staticRenderFns } from "./GiveFreeModal.vue?vue&type=template&id=1caba036&scoped=true"
import script from "./GiveFreeModal.vue?vue&type=script&lang=js"
export * from "./GiveFreeModal.vue?vue&type=script&lang=js"
import style0 from "./GiveFreeModal.vue?vue&type=style&index=0&id=1caba036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caba036",
  null
  
)

export default component.exports